/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/23/20
 *
 */

export const FeatureIdEnum = Object.freeze({
	DRIVE_STORAGE: "featureDriveStore",
})
